import {
    GET_USER_BIRTH_CHART_LIST,
    GET_USER_BIRTH_CHART_LIST_SUCCESS,
    GET_USER_BIRTH_CHART_LIST_FAIL
} from "./actionTypes"
import { RESULT_OK, RESULT_ERROR } from "../../baseActionTypes"

const INIT_STATE = {
    error: {},
    loading: false,
    actionResult: {},
    userBirthChartListPage: {}
}

const productAdminBirthChart = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_USER_BIRTH_CHART_LIST:
            return {
                loading: true,
                ...state,
                userBirthChartListPage: {},
            }
        case GET_USER_BIRTH_CHART_LIST_SUCCESS:
            return {
                ...state,
                userBirthChartListPage: action.payload,
                actionResult: { action: GET_USER_BIRTH_CHART_LIST_SUCCESS, result: RESULT_OK, error: '' },
                loading: false
            }

        case GET_USER_BIRTH_CHART_LIST_FAIL:
            return {
                ...state,
                userBirthChartListPage: {},
                actionResult: { action: GET_USER_BIRTH_CHART_LIST_FAIL, result: RESULT_ERROR, error: action.payload },
                loading: false
            }
        default:
            return state
    }
}

export default productAdminBirthChart